import { Icon } from "@iconify/react";
import { Button } from "@heroui/button";
import { Link } from "@heroui/link";
import React from "react";

import { ContactCardProps } from "@/types";

const ContactCard = ({ data }: ContactCardProps) => {
  return (
    <div
      className="rounded-2xl border border-foreground-200 p-4 inline-flex flex-col"
      data-aos="fade-up"
    >
      <div>
        <div className="p-1 border rounded-lg border-foreground-200 text-foreground inline-flex items-center justify-center text-xl ">
          <Icon icon={data.icon} />
        </div>
      </div>
      <div className="mt-6">
        <div className="text-foreground font-semibold">{data.title}</div>
        <div className="text-foreground-600">{data.description}</div>
      </div>
      <Button
        as={Link}
        className="mt-4 text-foreground-600 text-sm border"
        href={data.link.href}
        target={data.link.target}
        variant="bordered"
      >
        {data.link.label}
      </Button>
    </div>
  );
};

export default ContactCard;
